import { curryN } from 'ramda'
import getWithToken from './base/get-with-token'

const getCustomerWaterUsage = curryN(
    2,
    (id, query) => getWithToken(`/customer/${id}/water-usage`)(query)
)

export default getCustomerWaterUsage